import React from "react";
import ClientHeader from "../../Share/ClientHeader";
import { Outlet } from "react-router-dom";
import ClientFooter from "../../Share/ClientFooter";
import logo18 from "../../Css/img_news/logo_18.png";
import licenseLogo from "../../Css/img_news/giay_phep.png";
import Styles from "./ClientPage.module.scss";
function ClientPage(){

    return(
        <div>
            <div className={Styles.badges}>
                <img
                    className={Styles.licenseLogo}
                    src={licenseLogo}
                    alt="Giay phep phat hanh game so 635 QD-PTTH&TTDT"
                />
                <img
                    className={Styles.ageLogo}
                    src={logo18}
                    alt="Game danh cho nguoi tren 18 tuoi"
                />
            </div>

            <ClientHeader/>         
            {/* <PhoneReverificationModal/> */}
            <Outlet/>
            {/* <Messenger/> */}
           <ClientFooter/>
            
        </div>
    )
}

export default  ClientPage
